.wrap {
  position: relative;
}

.gear {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease, transform 0.35s ease;
}

.gear:hover {
  background: rgba(255, 255, 255, 0.1);
}

.wrap:has(.menu) .gear {
  transform: rotate(30deg);
  background: rgba(255, 255, 255, 0.1);
}

.menu {
  position: absolute;
  right: 0;
  bottom: calc(100% + 10px);
  min-width: 252px;
  background: rgba(14, 16, 20, 0.92);
  backdrop-filter: blur(18px) saturate(1.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 6px 0;
  z-index: 20;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.55);
  animation: menuIn 0.16s ease;
}

@keyframes menuIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.item,
.back {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;
  padding: 11px 16px;
  cursor: pointer;
  text-align: left;
}

.item:hover,
.back:hover {
  background: rgba(255, 255, 255, 0.07);
}

.item.active {
  background: rgba(225, 29, 46, 0.14);
}

.value {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  opacity: 0.85;
  color: #a8adb8;
}

.check {
  color: #ff4d5a;
  flex-shrink: 0;
}

.back {
  font-weight: 600;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 4px;
}
